import React from "react"
import { Link } from "react-router-dom"

export default function McpSettings() {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Connect an AI assistant</h2>
      <p className="text-sm text-gray-600">
        Add the server address below in an assistant that supports remote MCP servers and OAuth.
        Sign in to Heartily when prompted, check the account shown, and approve access.
      </p>
      <p className="text-sm"><Link to="/ai-assistants" className="font-medium text-indigo-600 hover:text-indigo-800">Setup guides for Claude, ChatGPT, Grok and more →</Link></p>
      <label className="block text-sm font-medium text-gray-700" htmlFor="mcp-server-url">Server address</label>
      <input
        id="mcp-server-url"
        readOnly
        value={document.querySelector('meta[name="mcp-server-url"]')?.content || "https://heartily.app/mcp"}
        onFocus={(event) => event.target.select()}
        className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-3 text-sm"
      />
      <p className="text-sm text-gray-600">
        Your assistant can read courses, assignments and grades. Students share their own data;
        parents share only their currently linked students. Access is read-only.
      </p>
      <a href="/oauth/authorized_applications" className="inline-flex min-h-11 items-center text-sm font-medium text-indigo-600 hover:text-indigo-800">
        Manage or disconnect connected apps
      </a>
    </div>
  )
}
